import React from "react";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import WorkHistoryListing from "./WorkHistoryListing";

type Props = {};

const WorkHistoryListingWrapper = (props: Props) => {
  return (
    <SideNavLayout>
      <WorkHistoryListing />
    </SideNavLayout>
  );
};

export default WorkHistoryListingWrapper;
